import { get, post } from '../http'

/** ???? */
export const getBalance = () => {
  return get('/api/recharge/balance')
}

/** ?????? */
export const createRecharge = (data) => {
  return post('/api/recharge/create', data)
}

/** ?????? */
export const queryOrder = (orderNo) => {
  return get(`/api/recharge/query/${orderNo}`)
}

/** ?????? */
export const getOrders = (params = {}) => {
  return get('/api/recharge/orders', params)
}

/** 查询充值/消费比例配置 */
export const getRechargeConfig = () => {
  return get('/api/recharge/config')
}

/** 设置充值/消费比例 */
export const updateRechargeConfig = (data) => {
  return post('/api/recharge/config', data)
}
